mutation MessageRecipientDelete(
  $messageDetailDeleteInput: MessageDetailDeleteInput!
) {
  messageDetailDelete(input: $messageDetailDeleteInput) {
    deletedEntities {
      id
    }
  }
}
